import { render, staticRenderFns } from "./AgentStlmt.vue?vue&type=template&id=4dab4d02"
import script from "./AgentStlmt.vue?vue&type=script&lang=js"
export * from "./AgentStlmt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-pharmacy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4dab4d02')) {
      api.createRecord('4dab4d02', component.options)
    } else {
      api.reload('4dab4d02', component.options)
    }
    module.hot.accept("./AgentStlmt.vue?vue&type=template&id=4dab4d02", function () {
      api.rerender('4dab4d02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/manager/pharmacy/Decoctingstlmt/AgentStlmt.vue"
export default component.exports